// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Branch details'"></sub-header>

<div class="tab-content user-details">
  <div class="tab-pane active">
    <form name="\$ctrl.branchForm">

      <div class="form-column">
        <!-- Core properties-->
        <form-section form-title="'Core properties'">
          <form-section-field field-title="'Organization'">
            <select
              required
              ng-disabled="\$ctrl.organizations && \$ctrl.organizations.length === 1"
              ng-model="\$ctrl.branch.organizationId"
              ng-options="o.id as o.name for o in \$ctrl.selectableOrganizations">
            </select>
          </form-section-field>
          <form-section-field field-title="'Name'">
            <input
              required
              type="text"
              ng-model="\$ctrl.branch.name"
              ng-minlength="1"
              ng-maxlength="64"/>
          </form-section-field>
          <form-section-field field-title="'Code'">
            <input
              type="text"
              ng-model="\$ctrl.branch.code"
              ng-minlength="1"
              ng-maxlength="8"/>
          </form-section-field>
          <form-section-field field-title="'Working hours'">
            <div class="horizontal">
              <glue-container append="'From'">
                <input
                  type="time"
                  ng-model="\$ctrl.branch.workingHoursFrom"/>
              </glue-container>
              <glue-container append="'To'">
                <input
                  type="time"
                  ng-model="\$ctrl.branch.workingHoursTo"/>
              </glue-container>
            </div>
          </form-section-field>
          <form-section-field field-title="'Holiday working hours'">
            <div class="horizontal">
              <glue-container append="'From'">
                <input
                  type="time"
                  ng-model="\$ctrl.branch.holidayWorkingHoursFrom"/>
              </glue-container>
              <glue-container append="'To'">
                <input
                  type="time"
                  ng-model="\$ctrl.branch.holidayWorkingHoursTo"/>
              </glue-container>
            </div>
          </form-section-field>
          <form-section-field field-title="'TIN'">
            <input
              type="text"
              ui-mask="999-999-999-999"
              ui-mask-placeholder
              ui-options="{clearOnBlur: false}"
              ng-model="\$ctrl.branch.tinNumber"
              ng-minlength="1"
              ng-maxlength="20"/>
          </form-section-field>
          <form-section-field field-title="'Started on'">
            <date ng-model="\$ctrl.branch.startedOn"></date>
          </form-section-field>
          <form-section-field field-title="'Working days'">
            <multiselect items="\$ctrl.workingDays"
                         ng-model="\$ctrl.branch.workingDays"
                         ng-required="true">
            </multiselect>
          </form-section-field>
        </form-section>
        <!-- Security management -->
        <form-section form-title="'Security settings'">
          <form-section-field field-title="'Is IP restricted'">
            <select
              required
              ng-model="\$ctrl.branch.ipAddressRestricted"
              boolean-options>
            </select>
          </form-section-field>
          <form-section-field field-title="'IP addresses (v4)'" ng-if="\$ctrl.branch.ipAddressRestricted">
            <selectize required
                       ng-model="\$ctrl.branch.ipAddresses"
                       options="\$ctrl.ipOptions"
                       config="\$ctrl.ipAddressesSelectizeConfig">
            </selectize>
          </form-section-field>
        </form-section>
        <!-- Contact data -->
        <form-section form-title="'Contact data'">
          <form-section-field field-title="'Phone number'">
            <telephone ng-model="\$ctrl.branch.phoneNumber"
                       ng-required="true"></telephone>
          </form-section-field>
          <form-section-field field-title="'Fax number'">
            <telephone ng-model="\$ctrl.branch.faxNumber"
                       ng-required="false"></telephone>
          </form-section-field>
        </form-section>
        <form-section form-title="'SSS configuration'">
          <form-section-field field-title="'SSS code'">
              <input
                  type="text"
                  maxlength="6"
                  ng-pattern="/^\\d{0,6}\$/"
                  ng-model="\$ctrl.branch.sssCode"/>
          </form-section-field>
        </form-section>
      </div>

      <div class="form-column">
        <!-- Address -->
        <form-section form-title="'Address'">
          <address ng-model='\$ctrl.branch.address' edit-mode="true" module="'branch'"></address>
        </form-section>
        <!-- Posting management -->
        <form-section form-title="'Posting management'">
          <form-section-field field-title="'Initial cash'">
            <cash ng-required="true"
              ng-disabled="\$ctrl.branch.id"
              ng-model="\$ctrl.branch.initialCash"></cash>
          </form-section-field>
          <form-section-field field-title="'CIV Limit'">
            <cash ng-model="\$ctrl.branch.civLimit"></cash>
          </form-section-field>
          <form-section-field field-title="'System date'">
            <date ng-required="true"
              ng-disabled="\$ctrl.branch.id"
              max="'3000-01-01'"
              ng-model="\$ctrl.branch.systemDate"
              ui-validate="'\$ctrl.isValidSystemDate(\$value)'"
              ui-validate-watch="['\$ctrl.branch.workingDays', '\$ctrl.branch.postingDate']"
              ></date>
          </form-section-field>
          <form-section-field field-title="'Posting date'">
            <date ng-required="true"
              ng-disabled="\$ctrl.branch.id"
              min="\$ctrl.minPostingDate()"
              max="\$ctrl.maxPostingDate()"
              ng-model="\$ctrl.branch.postingDate"
              ui-validate="'\$ctrl.isWithinWorkingDay(\$value)'"
              ui-validate-watch="'\$ctrl.branch.workingDays'"
            ></date>
          </form-section-field>
        </form-section>
        <!-- Check management -->
        <form-section form-title="'Check management'">
          <form-section-field field-title="'BRSTN'">
            <input
              type="text"
              ui-mask="999999999"
              minlength="9"
              maxlength="9"
              ng-model="\$ctrl.branch.brstn"/>
          </form-section-field>
          <form-section-field field-title="'Check cutoff time'">
            <input
              required
              type="time"
              ng-model="\$ctrl.branch.checkCutoffTime"/>
          </form-section-field>
          <form-section-field field-title="'Check clearing days'">
            <input
              required
              type="number"
              min="0"
              max="99"
              ng-model="\$ctrl.branch.checkCounterThreshold"/>
          </form-section-field>
          <form-section-field field-title="'Check clearing setting'">
            <select
              required
              ng-options="o.value as o.label for o in \$ctrl.checkClearingModes"
              ng-model="\$ctrl.branch.checkClearingMode"
              ng-change="\$ctrl.onCheckClearingModeChange()">
            </select>
          </form-section-field>
          <form-section-field field-title="'Check clearing time'" ng-if="\$ctrl.branch.checkClearingMode === 'AT_GIVEN_TIME'">
            <input
              required
              type="time"
              ng-model="\$ctrl.branch.checkClearingTime"/>
          </form-section-field>
        </form-section>
        <!-- POS management -->
        <form-section form-title="'POS management'">
          <form-section-field field-title="'POS transactions supported'">
            <select
              required
              ng-model="\$ctrl.branch.posSupport"
              ng-change="\$ctrl.onPosSupportChange(\$ctrl.branch.posSupport)"
              boolean-options>
            </select>
          </form-section-field>
          <form-section-field field-title="'POS license branch'" ng-if="\$ctrl.branch.posSupport">
            <select
              ng-model="\$ctrl.branch.posLicenseBranchId"
              ng-change="\$ctrl.updateDepositoryAccounts()"
              ng-options="o.id as o.name for o in \$ctrl.branches">
            </select>
          </form-section-field>
          <form-section-field field-title="'POS depository account'" ng-if="\$ctrl.branch.posSupport">
            <select
              required
              ng-model="\$ctrl.branch.posDepositoryAccountId"
              ng-options="o.id as o.accountName for o in \$ctrl.depositoryAccounts">
            </select>
          </form-section-field>
        </form-section>
        <!-- GL mapping management -->
        <form-section form-title="'Inter-branch GL management'">
          <form-section-field field-title="'Due from'">
            <selectize
              required
              options="\$ctrl.ledgerAccounts"
              config="\$ctrl.ledgerAccountSelectConfig"
              ng-model="\$ctrl.branch.dueFromAccountCode">
            </selectize>
          </form-section-field>
          <form-section-field field-title="'Due to'">
            <selectize
              required
              options="\$ctrl.ledgerAccounts"
              config="\$ctrl.ledgerAccountSelectConfig"
              ng-model="\$ctrl.branch.dueToAccountCode">
            </selectize>
          </form-section-field>
        </form-section>
      </div>
      <div class="form-column">
        <!-- Regulatory report parameters -->
        <form-section form-title="'Regulatory report properties'">
          <form-section-field field-title="'AMLA institution code'">
            <input
              type="text"
              ng-model="\$ctrl.branch.amlaInstitutionCode"
              ng-required="\$ctrl.isAMLAInstitutionCodeRequired"
              ui-mask="99999999999"/>
          </form-section-field>
          <form-section-field field-title="'Island region'">
            <select
              required
              ng-options="r.id as r.name for r in \$ctrl.regions"
              ng-model="\$ctrl.branch.geoLocationRegionId">
            </select>
          </form-section-field>
          <form-section-field field-title="'BSP branch name'">
            <input
              required
              type="text"
              ng-model="\$ctrl.branch.bspBranchName"
              ng-minlength="1"
              ng-maxlength="64"/>
          </form-section-field>
          <form-section-field field-title="'BSP branch address'">
            <input
              required
              type="text"
              ng-model="\$ctrl.branch.bspBranchAddress"
              ng-minlength="1"
              ng-maxlength="512"/>
          </form-section-field>
          <form-section-field field-title="'BSP branch code'">
            <input
              required
              type="text"
              maxlength="6"
              ng-pattern="/^\\d{0,6}\$/"
              ng-model="\$ctrl.branch.bspBranchCode"
              />
          </form-section-field>
          <form-section-field field-title="'Parent branch'">
            <select ng-options="b.id as b.name for b in \$ctrl.parentOptions"
                    ng-model="\$ctrl.branch.parentBranchId">
            </select>
          </form-section-field>
        </form-section>

        <form-section form-title="'Automated actions'">
          <form-section-field field-title="'Start of day'">
            <select boolean-options
                    required
                    ng-model="\$ctrl.branch.automaticStartDay">
            </select>
          </form-section-field>

          <form-section-field field-title="'Close counter'">
            <select boolean-options
                    required
                    ng-model="\$ctrl.branch.automaticCloseCounter">
            </select>
          </form-section-field>
        </form-section>

        <form-section form-title="'Automated Invoice'" ng-if="\$ctrl.automatedOfficialReceiptsEnabled">
          <form-section-field field-title="'Official Receipt number prefix'">
            <input
              type="text"
              ng-model="\$ctrl.branch.officialReceiptNumberPrefix"
              ng-maxlength="64"/>
          </form-section-field>

          <form-section-field field-title="'Official Receipt number suffix'">
            <input
              type="text"
              ng-model="\$ctrl.branch.officialReceiptNumberSuffix"
              ng-maxlength="64"/>
          </form-section-field>
        </form-section>
      </div>
    </form>
  </div>

  <div class="clearfix"></div>

  <div class="buttons">
    <button class="btn btn-warning"
            ng-disabled="\$ctrl.branchForm.\$pristine"
            ng-click="\$ctrl.cancel()">
      Cancel
    </button>
    <button class="btn btn-primary"
            ng-disabled="\$ctrl.branchForm.\$pristine || \$ctrl.branchForm.\$invalid"
            ng-click="\$ctrl.save()">
      Save
    </button>
  </div>

</div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/administration-branches/branch-details/branch-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;